var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 202,
    viewBox: "0 0 208 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.761 98.1414C207.761 126.162 195.425 151.595 177.193 169.945C158.961 188.295 133.712 201.457 105.909 201.457C78.1053 201.457 57.193 183.941 38.9614 165.576C20.7298 147.212 0 126.162 0 98.1414C0 70.1212 12 40.2773 30.2175 21.9129C48.4351 3.54847 78.0912 0 105.909 0C133.726 0 159.818 7.12522 178.049 25.4896C196.281 43.854 207.761 70.1353 207.761 98.1414Z",
    fill: "#F81958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.847 65.8688C97.764 82.7884 96.5626 82.4253 93.4792 99.3449C90.3958 116.265 90.2041 116.207 87.1207 133.126C86.9478 134.075 86.8842 134.498 86.1048 133.669C71.9763 118.624 71.0234 119.303 56.8948 104.258C56.6919 104.04 57.2473 103.323 56.9597 103.236C47.4568 100.364 47.5564 99.8174 38.0599 96.9469C37.3186 96.7228 35.9136 96.2923 36.0292 95.6579C38.3918 82.6937 40.3281 83.279 42.6897 70.3204C42.8063 69.6804 42.2578 69.6194 42.9991 69.8435C52.502 72.7159 52.4708 72.8869 61.9673 75.7574C62.2549 75.8443 63.2168 76.042 63.474 75.9626C81.3179 70.5824 81.2822 70.5192 99.1335 65.1354C100.118 64.8393 101.02 64.92 100.847 65.8688Z",
    fill: "#FAFF29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.311 81.7125C108.784 88.8214 109.84 89.8883 108.446 97.0181C107.051 104.148 104.516 104.098 98.6568 109.772",
    stroke: "#FAFF29",
    strokeWidth: 12,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.34 62.626C131.254 78.903 133.489 83.4995 130.716 97.7378C127.942 111.976 123.318 116.838 107.224 129.822",
    stroke: "#FAFF29",
    strokeWidth: 12,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.826 60.6968C154.693 82.1049 153.982 85.3759 152.675 103.765C151.303 123.216 148.899 127.302 128.939 139.711",
    stroke: "#FAFF29",
    strokeWidth: 12,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.efafc272a8e14c3d624030fb21bf32d9.svg";
export { ForwardRef as ReactComponent };